export default "__VITE_ASSET__DOv5yb_Z__$_?format=webp__"